import { CRYPTOYS_LEGION_KEY } from '../constants';

export const removeNonNumericCharacters = (input) => {
  // returns a string with all non-numeric characters removed
  // used for validating fields like phone number and card number
  return input.replace(/[^0-9]/gi, '');
};

export const capitalizeWord = (input) => {
  return input.charAt(0).toUpperCase() + input.slice(1);
};

export const getPhoneNumberWithCountryCode = (phone) => {
  phone = removeNonNumericCharacters(phone);
  if (phone.length === 10) {
    return '+1' + phone;
  }
  if (phone.length === 11 && phone[0] === '1') {
    return '+' + phone;
  }
  return '';
};

const getClientLocale = () => {
  if (typeof Intl !== 'undefined') {
    try {
      return Intl.NumberFormat().resolvedOptions().locale;
    } catch (err) {
      return 'en-US'; // default
    }
  }
};

export const formatCurrencyUSD = (number) => {
  const locale = getClientLocale();
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      currencySign: 'accounting'
    }).format(number);
  } catch {
    return `$${parseFloat(number).toFixed(2)}`;
  }
};

export const getNumCubes = (numCubes, maxNumCubes) => {
  const defaultNumCubes = 1;
  try {
    numCubes = parseInt(numCubes);
    if (!Number.isInteger(numCubes) || numCubes > maxNumCubes) {
      // The number of cubes is invalid or greater than the amount we have available
      // Return the default
      return defaultNumCubes;
    } else {
      return parseInt(numCubes);
    }
  } catch {
    return defaultNumCubes;
  }
};

export const redirectToCryptoysDrops = () => {
  window.location.replace(process.env.REACT_APP_DROPS_URL);
};

export const setLocalStorageDropStatus = (
  dropId,
  dropStatus,
  inventoryStatus
) => {
  localStorage.setItem(
    JSON.stringify({
      entity: 'drop-status',
      'drop-id': dropId
    }),
    JSON.stringify({
      dropStatus: dropStatus, // can be 'PENDING', 'ACTIVE', or 'COMPLETED'
      inventoryStatus: inventoryStatus // can be 'CLOSED', 'RESERVED', 'SOLDOUT'
    })
  );
};

export const resetReservation = (dropId, errorMessage) => {
  let queryParamString = '?dropId=' + dropId;
  if (!!errorMessage) {
    const errorParam = '&error=' + encodeURIComponent(errorMessage);
    queryParamString = queryParamString + errorParam;
  }
  window.location.replace(
    window.location.origin +
      process.env.REACT_APP_ROUTER_BASENAME +
      queryParamString
  );
};

export const calculateAge = (birthdate) => {
  const today = new Date();
  const birthDate = new Date(birthdate);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export const getLegionImage = (imageName) => {
  const imageData = JSON.parse(sessionStorage.getItem(CRYPTOYS_LEGION_KEY));
  return imageData ? imageData[imageName] : null;
};
